<!-- <img src='{{image}}'> -->

<div class="mat-headline">Welcome To {{name}}</div>
<div>
    <h4>Description: {{detail}}
    </h4>
</div>
<div *ngIf="isOptionValid(getOptionValue('CHANCE'))">
    <!-- <h2><button mat-raised-button color="primary" (click)="viewChance(chanceCardId);">View Chance</button></h2> -->
    <app-chance-detail [chanceId]="chanceCardId"></app-chance-detail>
</div>
<div *ngIf="isOptionValid(getOptionValue('QUARANTINE'))">
    <h2>Bad luck, you're now stuck in Quarantine</h2>
</div>
<div *ngIf="isOptionValid(getOptionValue('PAY_BILL'))">
    <h2>This startup is owned by player {{owner}}. You must pay the bill: {{productPrice}};</h2>
</div>
<div *ngIf="isOptionValid(getOptionValue('BUY_ASSET'))">
    <h3> Take the opportunity to found the startup '{{name}}' <br> Founding capital: {{price}}<br>
        <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedOption" style="display: inline-grid;">
            <mat-radio-button value="{{getOptionValue('BUY_ASSET')}}" [disabled]="insufficientBalance">Yes, great idea !</mat-radio-button>
            <div *ngIf="insufficientBalance" style="color: red;">&#x26A0; Your account balance is insufficient to found this startup!</div>
            <mat-radio-button value="{{getOptionValue('NOTHING')}}">Sorry, not interested</mat-radio-button>
        </mat-radio-group>
    </h3>
</div>
<h3>
    <p>Please <span *ngIf="selectedOption == undefined">choose your option and </span>validate</p>
    <button mat-raised-button color="primary" [disabled]="!canValidate || (selectedOption == undefined)" (click)="validate()">Validate</button>
</h3>
<div></div>
